export enum Outcome
{
    Won = 1,// = 'won', // 1
    Lost = 2,// = 'lost', // 2
    Unwinnable = 3,// = 'unwinnable', // 3
    Undetermined = 4,// = 'undetermined' // 4
}